export var BREAKPOINTS = {
  mobile: 360,
  mobileLarge: 412,
  tablet: 768,
  tabletLarge: 1024,
  desktop: 1200,
  desktopLarge: 1440,
  desktopHuge: 1800
};